// src/api/apiClient.js  (or your preferred path e.g., src/services/apiClient.js)
import axios from 'axios';

// Define the base URL for your Laravel API
// It's good practice to use environment variables for this
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request Interceptor:
// This function will be called before every request is sent.
apiClient.interceptors.request.use(
  (config) => {
    // Get the token from localStorage (or your AuthContext/state management)
    const token = localStorage.getItem('token');
    if (token) {
      // If the token exists, add it to the Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Optional: Response Interceptor for global error handling
apiClient.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response) {
      // The request was madeaxios and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        // Handle unauthorized access, e.g., token expired or invalid
        // You might want to clear the token and redirect to login
        console.error("API Error: Unauthorized (401). Token might be invalid or expired.");
        localStorage.removeItem('token'); // Clear potentially bad token
        // Redirect to login page.
        // This assumes you're using react-router-dom and have access to history or navigate.
        // If this file is outside React component tree, direct navigation might be tricky.
        // Often, this logic is handled within AuthContext or a higher-order component.
        // For simplicity here, we'll log it. Your AuthContext already handles navigation on fetchUserData error.
        // window.location.href = '/login'; // Force redirect if necessary
      } else if (error.response.status === 403) {
        console.error("API Error: Forbidden (403). User does not have permission.");
        // Optionally, show a generic "forbidden" message to the user
      }
      // You can add more global error handling here for other statuses like 500, 404 etc.
    } else if (error.request) {
      // The request was made but no response was received
      console.error('API Error: No response received from server.', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('API Error: Error setting up request.', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
